import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';
import InputAdornment from '@mui/material/InputAdornment';
import InfoTwoToneIcon from '@mui/icons-material/InfoTwoTone';

const headerFieldSx = {
  '& legend': { display: 'none' },
  '& fieldset': { top: 0 },
  '& .MuiInputBase-root': { position: 'relative' },
  '& .MuiInputBase-input': {
    textAlign: 'center',
    fontWeight: 600,
    paddingLeft: '20px',
    paddingRight: '20px',
    transform: 'translateX(4px)',
  },
  '& .MuiInputAdornment-positionEnd': {
    position: 'absolute',
    right: 8,
    margin: 0,
  },
  '& .MuiInputAdornment-root': {
    margin: 0,
  },
};

const HeaderCell = ({ value, tooltip }) => (
  <TextField
    fullWidth
    sx={headerFieldSx}
    size="small"
    variant="outlined"
    InputProps={{
      readOnly: true,
      endAdornment: (
        <InputAdornment position="end" sx={{ margin: 0 }}>
          <Tooltip title={tooltip} arrow placement="bottom" TransitionComponent={Zoom}>
            <InfoTwoToneIcon fontSize={'string'} />
          </Tooltip>
        </InputAdornment>
      ),
      style: { fontWeight: 600 },
    }}
    disabled
    value={value}
  />
);

const LabelContainer = () => {
  return (
    <div className="labelContainer layered-soil-layer">
      <HeaderCell value="Layer Id" tooltip="Soil layer ID" />
      <HeaderCell value="Formation" tooltip="Formation." />
      <HeaderCell
        value="z₁"
        tooltip="Starting point of soil layer measured from ground surface (m). Equal to foundation depth at the first soil layer."
      />
      <HeaderCell value="z₂" tooltip="Ending point of soil layer measured from ground surface (m)." />
      <HeaderCell value="Hᵢ" tooltip="Soil layer thickness (m). Equals to z2-z1 of corresponding soil layer." />
      <HeaderCell value="c" tooltip="Cohesion of the soil layer (kPa)." />
      <HeaderCell value="φ" tooltip="Friction angle of the soil layer (degree)." />
    </div>
  );
};

export default LabelContainer;
